<fin-corporate-hero
  [title]="'CORPORATE.corporatePortal.home.title' | finLocalization"
  [description]="description$ | async | finLocalization"
  [showBookingWidget]="true"
></fin-corporate-hero>

<div class="grid-col-12 grid-max-width">
  <div class="col-1-12 ms-xxlarge-t">
    @if (showWidgets$ | async) {
      <div>
        <h4 class="font-heading-4 ms-large-b">
          {{ 'CORPORATE.corporatePortal.home.widgetTitle' | finLocalization }}
        </h4>
        <div class="mr-large-b flex widget-grid flex--wrap">
          @if (trip$ | async) {
            <div class="widget">
              <fin-your-next-trip-widget [trip$]="trip$"></fin-your-next-trip-widget>
            </div>
          }
          <div class="widget">
            <fin-next-trips-widget></fin-next-trips-widget>
          </div>
          <div class="widget">
            <fin-corporate-benefits-widget></fin-corporate-benefits-widget>
          </div>
          @if (showSafWidget$ | async) {
            <div class="widget">
              <fin-saf-widget></fin-saf-widget>
            </div>
          }
        </div>
      </div>
    }

    <div class="mr-large-b">
      <fcom-notification
        *ngIf="(profile$ | async)?.isCorporate === false"
        class="ms-large-b"
        data-testid="f-plus-notification"
        [title]="'CORPORATE.corporatePortal.home.finnairPlusNotificationTitle' | finLocalization"
      >
        {{ 'CORPORATE.corporatePortal.home.finnairPlusNotification' | finLocalization }}
      </fcom-notification>
      <h3 class="font-heading-4 ms-large-b">
        {{ 'CORPORATE.corporatePortal.home.discoverMore' | finLocalization }}
      </h3>
      <fin-image-cards></fin-image-cards>
    </div>

    <div class="ms-small-t ms-xxlarge-b">
      <h3 class="font-heading-4 ms-large-b">
        {{ 'CORPORATE.corporatePortal.home.usefulLinks' | finLocalization }}
      </h3>
      <fin-quick-links></fin-quick-links>
    </div>
  </div>
</div>
